import { Component, OnInit, ViewChild, AfterViewInit,ChangeDetectorRef } from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { SocketServiceService } from '../services/socket-service.service';
import { ReportService } from '../services/report.service';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.scss']
})
export class ActivitylogComponent implements OnInit {
  onlineUserDetails: any;
  userDetails: any;
  dataSource: any;
  openBetsLength: any;
  pageSize: number;
  MatchList: any;
  searchMatch:any;
  layData: any = [];
  backData: any = [];
  betList: boolean;

  constructor(private route: ActivatedRoute, private sport: SportService,private cdRef:ChangeDetectorRef, private reportService: ReportService,
    private cookie: CookieService, private toastr: ToastrService, private socketService: SocketServiceService, private router: Router) { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.getOnlineUsersList();
    this.getSportList();
  }
  statement() {
    this.router.navigate(['statement'])
  }
  profitLoss() {
    this.router.navigate(['eventpl'])
  }
  info() {
    this.router.navigate(['info'])
  }
  history() {
    this.router.navigate(['history'])
  }
  activity() {
    this.router.navigate(['activity'])
  }
  rollComission() {
    this.router.navigate(['rollComission'])
  }
  getOnlineUsersList() {
    let data = {}
      this.reportService.userActivity(data).subscribe(res => {
        if(res.status){
          this.onlineUserDetails = res.data
        } else {
          this.onlineUserDetails = [];
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
        }
      })
    }
    openBets(params) {
      this.pageSize = 200
      let data = {
        page: 1,
        limit: this.pageSize,
        search: {
          "match_id": params.match_id,
          "delete_status":0
        }
      }
      this.reportService.openBets(data).subscribe((res) => {
        if (res.status) {
          if (res.data[0].data) {
            this.betList = true;
            this.dataSource = res.data[0].data;
            this.openBetsLength = res.data[0].data.length;
            this.backData = this.dataSource.filter(t => t.is_back == 1);
            this.layData = this.dataSource.filter(t => t.is_back == 0);
            this.cdRef.detectChanges();
          } else {
            this.openBetsLength = 0;
          }
  
  
        } else {
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
          this.openBetsLength = 0;
        }
      })
    }
    getSportList() {
      let data = {
        type: 'openBets',
        search: {}
      };
      this.reportService.eventList(data).subscribe((res) => {
        if (res.status == true) {
          this.betList = false;
          this.MatchList = res.data[0].matches;
        } else {
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
        }
      })
    }
}
